/* eslint-disable no-console */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FilterOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Input } from "../../atoms";
import { openModal } from "../../../redux/data/modals/modalReducer";
import { PageToolbar } from "../../molecules";
import { useFirestoreCollection } from "../../../hooks/useFirestoreCollection";
import { fetchVendor83788FromFirestore } from "../../../firestore/firestoreService";
import {
  listenToVendor83788,
  listenToVendor83788Filter,
} from "../../../redux/data/vendor83788/vendor83788Actions";

export const VendorsListToolbar: React.FC = () => {
  const { filterVendor83788 } = useSelector((state: any) => state.vendor83788);
  const dispatch = useDispatch();
  useFirestoreCollection({
    query: () => fetchVendor83788FromFirestore([]),
    data: listenToVendor83788,
    deps: [dispatch],
  });
  const handelAddBoard = () => {
    dispatch(
      openModal({
        modalType: "AddVendorModal",
        modalProps: { title: "Add Vendor" },
      })
    );
  };
  const handelOnSearch = (value: string) => {
    dispatch(
      listenToVendor83788Filter({ ...filterVendor83788, name: [value] })
    );
  };
  const handelRestFilter = () => {
    dispatch(listenToVendor83788Filter({}));
  };
  return (
    <PageToolbar>
      <Button
        type="primary"
        onClick={handelAddBoard}
        block
        icon={<PlusOutlined />}
        className="page-toolbar-btn"
      >
        Add Vendor
      </Button>

      <div className="page-toolbar-right-children-elements">
        <Input.Search
          placeholder="Search Vendor"
          allowClear
          onSearch={handelOnSearch}
          style={{ width: 304 }}
        />
        <Button
          type="link"
          onClick={handelRestFilter}
          icon={<FilterOutlined />}
          className="page-toolbar-btn-link"
        >
          Reset Filters
        </Button>
      </div>
    </PageToolbar>
  );
};
